import {action, makeObservable, observable} from "mobx";
import {OptInJackpotBetDialogComponent} from "../../components/jackpot-bet/opt-in/opt-in-jackpot-bet-dialog.component";
import {IServiceFactoryExtended} from "../service-factory-extended.interface";
import {ServiceBase} from "../ServiceBase";
import {DialogResult} from "../specific-dialogs/specific-dialogs.service.interface";
import {LocalStorageKeys} from "../storage/local-storage-keys";
import {IJackpotBetService} from "./jackpot-bet.service.interface";

export class JackpotBetService extends ServiceBase implements IJackpotBetService {
    constructor(serviceFactory: IServiceFactoryExtended) {
        super(serviceFactory);
        makeObservable(this);

        this._isJackpotBetOn = this.services.localStorage.getJson(LocalStorageKeys.isJackpotBetOn);
    }

    @observable.ref
    private _isJackpotBetOn: boolean;
    get isJackpotBetOn(): boolean {
        return this._isJackpotBetOn;
    }

    @action.bound
    toggleJackpotBet(): void {
        this._isJackpotBetOn = !this._isJackpotBetOn;
        this.services.localStorage.setItem(LocalStorageKeys.isJackpotBetOn, true);
    }

    showOptInJackpotBetDialog(): Promise<DialogResult> {
        if(!this._isJackpotBetEnabled)
        {
            return Promise.resolve(DialogResult.Accepted)
        }

        return new Promise<DialogResult>(resolve => {
            this.services.dialog.showModal(dialogHandler => <OptInJackpotBetDialogComponent
                dialogHandler={dialogHandler}
            />, {
                title: this.services.translation.translate('JACKPOT_BET'),
                hideDialogHeader: true,
                forceTransparentBackground: true,
                disableFullscreenMobile: true,
                forceCentralization: true,
                shouldBeClosedOnlyByUser: true,
                mobileCenterHeader: true,
                noDefaultContentPadding: true,
            });
        })
    }

    private _isJackpotBetEnabled(): boolean {
        return this.services.abTestingFeatureDataProvider.jackpotBet.isEnabled;
    }
}